import {Alert, Button, Card, Checkbox, DatePicker, Form, Input, Radio, Select, Space, Switch} from "antd";
import {FormattedMessage} from "react-intl";
import {CaretDownOutlined, SearchOutlined} from "@ant-design/icons";
import React from "react";
import Tooth from "../components/patient/Tooth";
import {accessibilityRoles} from "../utils/accessUtils";
import AccessControl from "../components/common/AccessControl";


const {Option} = Select;

const Components: React.FC = () => {

    return (
        <AccessControl
            accessibleFor={[accessibilityRoles.PLATFORM_ADMINISTRATOR]}>
            <Card
                title={<FormattedMessage id="register"/>}
                bordered={false}
                className="container"
            >
                <Form layout="vertical">
                    <Form.Item
                        className={"dentobook-form-item dentobook-simple-input"}
                        label="Email"
                        name="1"
                        rules={[{required: true, message: 'Please enter your email'}]}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        className={"dentobook-form-item dentobook-simple-input"}
                        name="2"
                    >
                        <Input placeholder={"Test"}/>
                    </Form.Item>

                    <Form.Item
                        className={"dentobook-form-item dentobook-simple-input"}
                        name="3"
                    >
                        <Input disabled={true}/>
                    </Form.Item>

                    <Form.Item
                        name="3"
                    >
                        <Input
                            className={"dentobook-form-item prefix-input"} prefix={<SearchOutlined/>}/>
                    </Form.Item>

                    <Form.Item
                        className={"dentobook-form-item"}
                        name="gender"
                        label="Gender"
                        rules={[{required: true}]}
                    >
                        <Select
                            size={"large"}
                            placeholder="Select a option and change input text above"
                            allowClear
                        >
                            <Option value="male">male</Option>
                            <Option value="female">female</Option>
                            <Option value="other">other</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        className={"dentobook-form-item"} label="Checkbox" name="chbox" valuePropName="checked">
                        <Checkbox>Checkbox</Checkbox>
                    </Form.Item>
                    <Form.Item
                        className={"dentobook-form-item"} label="Checkbox" name="chbox-disabled" valuePropName="checked">
                        <Checkbox disabled={true}>Checkbox</Checkbox>
                    </Form.Item>
                    <Form.Item
                        className={"dentobook-form-item"} label="Radio">
                        <Radio.Group>
                            <Radio value="apple">Apple</Radio>
                            <Radio value="pear">Pear</Radio>
                            <Radio value="pear" disabled={true}>Disabled</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item
                        name="5"
                        className={"dentobook-form-item"}
                    >
                        <Input prefix={<SearchOutlined/>} disabled={true}/>
                    </Form.Item>

                    <Form.Item
                        className={"dentobook-form-item"}
                        name="gender"
                        label="Gender"
                        rules={[{required: true}]}
                    >
                        <Select
                            size={"large"}
                            placeholder="Select a option and change input text above"
                            allowClear
                            suffixIcon={<CaretDownOutlined />}
                        >
                            <Option value="male" className={"dentobook-select-option"}>male</Option>
                            <Option value="female" className={"dentobook-select-option"}>female</Option>
                            <Option value="other" className={"dentobook-select-option"}>other</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        className={"dentobook-form-item"}
                        name="gender1"
                        label="Gender"
                        rules={[{required: true}]}
                    >
                        <Select
                            suffixIcon={<CaretDownOutlined />}
                            disabled={true}
                            size={"large"}
                            placeholder="Select a option and change input text above"
                            allowClear
                        >
                            <Option value="male">male</Option>
                            <Option value="female">female</Option>
                            <Option value="other">other</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        className={"dentobook-form-item"}
                        label={<FormattedMessage id="birth_date"/>}>
                        <DatePicker
                            size={"large"}
                            bordered={true}
                        />
                    </Form.Item>

                    <Form.Item
                        className={"dentobook-form-item"}
                        label={<FormattedMessage id="birth_date"/>}>
                        <DatePicker
                            disabled={true}
                            size={"large"}
                            bordered={true}
                        />
                    </Form.Item>

                    <Form.Item
                        className={"dentobook-form-item"} label="Checkbox" name="chbox" valuePropName="checked">
                        <Checkbox>Checkbox</Checkbox>
                    </Form.Item>
                    <Form.Item
                        className={"dentobook-form-item"} label="Checkbox" name="chbox-disabled" valuePropName="checked">
                        <Checkbox disabled={true}>Checkbox</Checkbox>
                    </Form.Item>
                    <Form.Item
                        className={"dentobook-form-item"} label="Radio">
                        <Radio.Group>
                            <Radio value="apple">Apple</Radio>
                            <Radio value="pear">Pear</Radio>
                            <Radio value="pear" disabled={true}>Disabled</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Space direction="vertical">
                        <Switch defaultChecked/>
                        <Switch/>
                        <Switch disabled/>
                    </Space>
                    <Space className="mb-5" direction="vertical" style={{width: '100%'}}>
                        <Alert className="dentobook-alert" message="Success Text" type="success" showIcon closable/>
                        <Alert className="dentobook-alert" message="Info Text" type="info" showIcon/>
                        <Alert className="dentobook-alert" message="Warning Text" type="warning" showIcon/>
                        <Alert className="dentobook-alert" message="Error Text" type="error" showIcon/>
                    </Space>

                    <Form.Item>
                        <Button
                            className={"dentobook-btn-primary dentobook-btn-large"}
                            type="primary" htmlType="submit">
                            Register
                        </Button>
                    </Form.Item>

                    <Form.Item>
                        <Button
                            className={"dentobook-btn-secondary dentobook-btn-medium"}
                            type="primary" htmlType="submit">
                            Register
                        </Button>
                    </Form.Item>

                    <Form.Item>
                        <Button
                            disabled={true}
                            className={"dentobook-btn-primary dentobook-btn-medium"}
                            type="primary" htmlType="submit">
                            Register
                        </Button>
                    </Form.Item>
                </Form>

                <Tooth selected={false} multiSelectionMode={false} milk={false} position={21} statusLabel='ads'/>
                <Tooth selected={false} multiSelectionMode={false} milk={false} position={11} statusLabel='ads'/>
                <Tooth selected={false} multiSelectionMode={false} milk={false} position={17} statusLabel='ads'/>
                <Tooth selected={false} multiSelectionMode={false} milk={false} position={31} statusLabel='ads'/>
                <Tooth selected={false} multiSelectionMode={false} milk={false} position={37} statusLabel='ads'/>
            </Card>
        </AccessControl>
    )
};

export default Components;
